import klineStyle from '../echartsOption/klineStyle';

/**
 * 定义成交量类
 */
class VOLUME {
    /**
     * 成交量类构造函数
     * @param {Array<Number>} vols 成交量序列
     * @param {Array<Number>} klineDatas K线数据序列
     */
    constructor(vols, klineDatas) {
        this.datas = vols;

        this.seriesOptions = {
            name: 'Volume',
            type: 'bar',
            xAxisIndex: 1,
            yAxisIndex: 1,
            data: [],
            itemStyle: {
                normal: {
                    color(params) {
                        var colorList;
                        if (klineDatas[params.dataIndex][1] > klineDatas[params.dataIndex][0]) {
                            colorList = klineStyle.lineColor.color;
                        } else {
                            colorList = klineStyle.lineColor.color0;
                        }
                        return colorList;
                    }
                }
            }
        };
    }

    /**
     * 生成Series选项
     * @returns {Object} 返回生成的echarts的option对象
     */
    generateSeriesOption() {
        this.seriesOptions.data = this.datas;
        return this.seriesOptions;
    }
}

export default VOLUME;



// WEBPACK FOOTER //
// ./src/controller/series/VOLUME.js